import Button from "@mui/material/Button";
import React from "react";

interface ButtonPrimaryProps {
  onClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  sx?: object;
  [key: string]: any; // pour permettre d'autres props MUI comme "disabled", "type", etc.
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  onClick,
  children,
  disabled,
  sx,
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      disabled={disabled}
      sx={{
        bgcolor: "hsl(var(--primary))",
        color: "hsl(var(--primary-foreground))",
        "&:hover": {
          bgcolor: "hsl(var(--primary))",
          opacity: 0.9,
        },
        "&:disabled": {
          bgcolor: "hsl(var(--muted))",
          color: "hsl(var(--muted-foreground))",
        },
        textTransform: "none",
        py: "8px",
        px: "16px",
        borderRadius: "6px",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ButtonPrimary;
